'use client';

import React from 'react';

interface OdsazeniProps {
  children: React.ReactNode;
  level?: 1 | 2 | 3;
}

export function Odsazeni({ children, level = 1 }: OdsazeniProps) {
  const paddingClasses = {
    1: 'pl-6 md:pl-12',
    2: 'pl-9 md:pl-16',
    3: 'pl-12 md:pl-20',
  };

  return (
    <div className={`my-6 ${paddingClasses[level]}`}>
      {children}
    </div>
  );
}
